import { render, staticRenderFns } from "./pinterestImage.vue?vue&type=template&id=4936aafe"
import script from "./pinterestImage.vue?vue&type=script&lang=js"
export * from "./pinterestImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports